import React from 'react';

/** Gradient modal headline — short entity name (e.g. color). */
export function ModalWordmarkTitle({ children }) {
  return (
    <span className="block text-[1.35rem] font-light leading-tight tracking-[0.28em] text-white sm:text-[1.6rem] lowercase">
      {children}
    </span>
  );
}

/** “Edit” + wordmark second line, for gradient headers. */
export function ModalWordmarkEditTitle({ children }) {
  return (
    <span className="flex flex-wrap items-baseline gap-x-2.5 gap-y-0.5 text-white">
      <span className="text-sm font-medium text-white/85">Edit</span>
      <span className="text-[1.15rem] font-light tracking-[0.28em] text-white sm:text-[1.35rem] lowercase">
        {children}
      </span>
    </span>
  );
}
